import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Loader } from '@/components/Loader';
import { HOME_ROUTES } from '../consts';

export function AuthSuccess() {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // Check if user is logged in after OAuth
    if (user) {
      // Redirect to appropriate home route based on user role
      navigate(HOME_ROUTES[user.role || 'USER'], { replace: true });
    } else {
      // If no user is found, redirect to login page
      navigate('/login', { replace: true });
    }
  }, [user, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <Loader />
        <p className="mt-4">Completing sign-in...</p>
      </div>
    </div>
  );
}
